import { ResourceOptions } from 'react-admin';
import { FaFire } from 'react-icons/fa';
import { Resources } from '../resource';

export { default as list } from './List';

export const name = Resources.hotSymbols;
export const icon = FaFire;
export const options: ResourceOptions = {
  label: 'resource.hotSymbols',
};
